const state = { 
  isPc: false,//判斷是設備  
  viewShow:false,//显示隐藏
  userInfo:null,//用户消息
  teacherInfo:null,//老师消息 
}
export default state
